/** Client-side mirror of API stage map for kanban / badges before catalog loads. */
export const SYSTEM_STATUS_STAGES: Record<string, string> = {
  quote: 'intake',
  pending_review: 'intake',
  intake: 'intake',
  pending_sig: 'intake',
  in_queue: 'in_progress',
  diagnosing: 'in_progress',
  waiting_auth: 'waiting',
  awaiting_approval: 'waiting',
  approved: 'in_progress',
  waiting_parts: 'waiting',
  in_repair: 'in_progress',
  on_hold: 'waiting',
  ready: 'ready',
  pending_pay: 'ready',
  closed: 'closed',
  warranty: 'closed',
  cancelled: 'cancelled',
  voided: 'cancelled',
};
